import { render } from "./MyView.vue?vue&type=template&id=4ffb99df&scoped=true"
import script from "./MyView.vue?vue&type=script&lang=js"
export * from "./MyView.vue?vue&type=script&lang=js"

import "./MyView.vue?vue&type=style&index=0&id=4ffb99df&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ffb99df"]])

export default __exports__